import React from 'react';

import { UiButton } from '../../ui/ui-button';
import { UiRichTextEditor } from '../../ui/ui-rich-text-editor';

import { richTextEditorConfig } from '../../util/ckeditor-config';
import { focusRichTextEditor } from '../../util/focus-rich-text-editor';

type InputProps = {
  comment: string;
  clearDraft: () => void;
  saveDraft: (comment: string, commentId?: number) => void;
  saveComment: (comment: string) => void;
  isEditing?: boolean;
  cancel?: () => void;
  commentId?: number;
};

export const CommentEditor = ({
  comment,
  saveComment,
  saveDraft,
  clearDraft,
  isEditing,
  cancel,
  commentId,
}: InputProps) => {
  if (isEditing && !cancel) {
    throw new Error(
      'Improperly configured component, cancel method must be provided if isEditing is true',
    );
  }

  const handleEnterComment = (e: { editor: { getData: Function } }) => {
    const message = e.editor.getData();
    if (isEditing) {
      saveDraft(message, commentId);
    } else {
      saveDraft(message);
    }
  };

  const handleAddComment = () => {
    saveComment(comment);
    clearDraft();
  };

  const handleCancel = () => {
    if (cancel) {
      cancel();
    }
  };

  return (
    <>
      <UiRichTextEditor
        data={comment}
        onChange={handleEnterComment}
        config={richTextEditorConfig}
        onInstanceReady={focusRichTextEditor}
      />
      <div className="u-textAlign-right u-margin-top">
        {isEditing && (
          <UiButton
            disabled={!comment || comment.length === 0}
            onClick={handleCancel}
            variant="secondary"
            className="u-margin-right"
          >
            Cancel
          </UiButton>
        )}
        <UiButton disabled={!comment || comment.length === 0} onClick={handleAddComment}>
          Save
        </UiButton>
      </div>
    </>
  );
};
